import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import AuthClient from "../../api/AuthClient";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes/routes";
import { parseMyPartyResponse } from "../../api/parseResponse/parseMyPartiesResponse";
import AlsoGoingOutGroupsApi from "../../api/AlsoGoingOutGroupsApi";
import RefreshButton from "../RefreshToUpdateData/RefreshToUpdateButton";
import { PartiesContext } from "../../GlobalContext/partiesContext";
import { LoadingAnimationContext } from "../../GlobalContext/loadingAnimation";
import { CitiesInfoContext } from "../../AllCitiesContext";
import AlsoGoingOutContent from "./AlsoGoingOutContent";


const AlsoGoingOut: React.FC = () => {

  const { alsoGoingOutGroups, setAlsoGoingOutGroupsContextData } = useContext(PartiesContext);
  const { alsoGoingOutHasLoadedOnce, setAlsoGoingOutHasLoadedOnce } = useContext(LoadingAnimationContext);

  const authClient = useMemo(() => new AuthClient(), []);
  const isLoggedIn = authClient.isLoggedIn();

  const navigate = useNavigate();

  const [refreshRequest, setRefreshRequest] = useState(false);
  const [requeststate, setRequestState] = useState('idle');
  const [isLoadingGroups, setIsLoadingGroups] = useState(!alsoGoingOutHasLoadedOnce);

  const { selectedCity } = useContext(CitiesInfoContext);
  const [lastFetchedCity, setLastFetchedCity] = useState<string | null>(null);

  const fetchGroups = useCallback(() => {
    setIsLoadingGroups(true);
    setRequestState('loading');
    const parties = new AlsoGoingOutGroupsApi(authClient);

    const citySelected = localStorage.getItem("cityInfo");
    const selectedCityInfo = citySelected ? JSON.parse(citySelected) : null;
    const cityId = selectedCityInfo?.cityId ?? null;

    parties.getAlsoGoingOutGroups(cityId).then((response) => {
      if (response?.data) {
        const parsedData = response.data.map(parseMyPartyResponse);
        setAlsoGoingOutGroupsContextData(parsedData);
      }

      setLastFetchedCity(cityId);
      setAlsoGoingOutHasLoadedOnce(true);
      setIsLoadingGroups(false);
      setRequestState('idle');
      setRefreshRequest(false);
    }).catch((err) => {
      console.error("Error fetching groups:", err);
      setAlsoGoingOutHasLoadedOnce(true);
      setIsLoadingGroups(false);
      setRequestState('idle');
      setRefreshRequest(false);
    });
  }, [authClient, setAlsoGoingOutGroupsContextData, setAlsoGoingOutHasLoadedOnce]);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(routes.Login);
      return;
    }

    const citySelected = localStorage.getItem("cityInfo");
    const currentCityId = citySelected ? JSON.parse(citySelected)?.cityId : null;
    const cityChanged = alsoGoingOutHasLoadedOnce && currentCityId !== lastFetchedCity;

    if (!alsoGoingOutHasLoadedOnce || refreshRequest || cityChanged) {
      fetchGroups();
    }
  }, [refreshRequest, selectedCity, isLoggedIn, alsoGoingOutHasLoadedOnce, lastFetchedCity, fetchGroups, navigate]);


  if (alsoGoingOutGroups === null) {
    return null;
  }
  const handleButtonClick = () => {
    setRefreshRequest(true)
  };


  return (
    <>
      <div className="mb-3 refreshRequestContainer">
        <RefreshButton requestState={requeststate} onClickHandler={handleButtonClick} />
      </div>
      <AlsoGoingOutContent
        isLoadingGroups={isLoadingGroups}
        alsoGoingOutGroups={alsoGoingOutGroups}
        authClient={authClient}
      />

    </>
  );
};

export default AlsoGoingOut;
